//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tooltip from "../Tooltip/Tooltip";
import Icon from "../Icon/Icon";
import Alignable from "../../mixins/Alignable";
import {mdiEarth, mdiFacebook, mdiInstagram, mdiTwitter, mdiYoutube} from '@mdi/js'

export default {
    name: 'SocialIcons',

    mixins: [Alignable],

    components: {Tooltip, Icon},

    props: {

        // The social media items
        socialMedia: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            icons: {
                facebook: mdiFacebook,
                twitter: mdiTwitter,
                instagram: mdiInstagram,
                youtube: mdiYoutube,
                website: mdiEarth,
            }
        }
    },

    computed: {
        socialMediaItems() {
            let types = ['website', 'instagram', 'facebook', 'youtube', 'twitter'];
            let names = {
                'website': 'Website', 'instagram': 'Instagram', 'facebook': 'Facebook', 'youtube': 'YouTube', 'twitter': 'Twitter'
            };

            let items = [];
            types.forEach(type => {
                if (this.socialMedia[type] || this.socialMedia[type + '_url']) {
                    items.push({
                        type: type,
                        url: this.socialMedia[type + '_url'] ? this.socialMedia[type + '_url'] : this.socialMedia[type],
                        name: names[type]
                    });
                }
            })

            return items;
        }
    }
}
